










































































































































































import mixins from 'vue-typed-mixins';
import { mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import AppealResultDropdown from '@/Shared/AppealResultDropdown.vue';
import AppealReasonDropdown from '@/Shared/AppealReasonDropdown.vue';
import NoteControls from './Notes/NoteControls.vue';
import { SearchPayload, AppealHearingPayload, CitationInfoPayload } from '@/Stores/AppealStore';
import { CitationInfo } from './Information/CitationInfo';
import { Appeal } from './Information/Appeal';
import { AppealInfo } from './Information/AppealInfo';
import { SearchParams } from './Citation/SearchParams';
import constants from '@/constants';
import fileSaver from 'file-saver';
import VatsAPI from '@/Shared/VatsAPI';

const msgBoxOptions = {
    centered: true,
    okVariant: 'danger',
    cancelDisabled: true,
    modalClass: 'deleteRowClass',
    hideBackdrop: true
};

const saveMsgBoxOptions = {
    centered: true,
    okVariant: 'success',
    hideBackdrop: true
};

const component = mixins(LocationBasedMixin).extend({
    data() {
        return {
            i18nPrefix: 'appeals.appealInfo',
            citationAmt: 0,
            originalAmt: 0,
            originalReviewDecision: null,
            appealDecision: null,
            viewNotesDisabled: true,
            editNotes: false,
            addNotes: false
        };
    },
    components: {
        AppealResultDropdown,
        AppealReasonDropdown,
        NoteControls,
    },
    computed: {
        ...mapGetters('appealModule', [
            'searchError',
            'searchInProgress',
            'searchParams',
            'getAppealInfo',
            'getHearingInfo',
            'getAppellant',
            'appellantLoaded',
            'getSearchResults',
            'appealInfoLoaded',
            'hearingInfoLoaded',
            'getAppealResultList',
            'checkAppellantRequiredFields',
            'notesLoaded',
            'getNotes'
        ]),
        results(): AppealInfo {
            if (this.appealInfoLoaded) {
                return this.getAppealInfo || new AppealInfo();
            }
            return new AppealInfo();
        },
        systemNotes() {
            const sres = this.getSearchResults;
            if (sres.hasOwnProperty('brokenMeterMessage')) {
                if (sres.brokenMeterMessage !== '') {
                    const message: TranslateResult = this.$t('appeals.brokenMeter');
                    return message + ' ' + sres.brokenMeterMessage;
                }
            }
            return '';
        },
    },
    mounted() {
        if (!this.getSearchResults.citationNumber) {
            return;
        }

        const searchParams = new SearchParams();
        searchParams.citationNumber = this.getSearchResults.citationNumber;
        searchParams.vehicleState = this.getSearchResults.vehicleState;
        searchParams.vehicleLicense = this.getSearchResults.vehicleLicense;

        const payload: SearchPayload = {
            parameters: searchParams,
            location: this.$typedStore.state.currentLocation
        };

        if (!this.appealInfoLoaded) {
            this.$typedStore.modules.appealModule.actions.searchAppealInfo(payload).then(() => {
                this.$data.originalReviewDecision = this.getAppealInfo.appeal.appealDecision;
                this.$data.appealDecision = this.getAppealInfo.appeal.appealDecision || null;
            });
        }

        this.$data.citationAmt = this.getSearchResults.remainingBalance.toFixed(2);
        this.$data.originalAmt = this.getSearchResults.remainingBalance.toFixed(2);
        this.$data.originalReviewDecision = this.getAppealInfo.appeal.appealDecision || null;
        this.$data.appealDecision = this.getAppealInfo.appeal.appealDecision || null;

        if (!this.appellantLoaded) {
            this.$typedStore.modules.appealModule.actions.searchAppellant(payload);
        }

        if (!this.notesLoaded) {
            this.$typedStore.modules.appealModule.actions.loadNotes(payload).then(() => {
                if (this.getNotes.length) {
                    this.$data.viewNotesDisabled = false;
                }
            });
        }

        if (this.getNotes.length) {
            this.$data.viewNotesDisabled = false;
        }
    },
    methods: {
        async addNotesEvent(v: boolean) {
            this.$data.addNotes = v;
            if (this.$data.editNotes && v === true) {
                this.$data.editNotes = false;
            }
        },
        async editNotesEvent(v: boolean) {
            this.$data.editNotes = v;
            if (this.$data.addNotes && v === true) {
                this.$data.addNotes = false;
            }
        },
        async printAppeal() {
            const response = (await VatsAPI.post<Blob>(`/${this.$typedStore.state.currentLocation.urlSegment}/citations/appealstatement`,
            {
                appeal: null,
                hearing: null,
                action: 'Print',
                citationNumber: this.getSearchResults.citationNumber,
                vehicleState: this.getSearchResults.vehicleState,
                vehicleLicense: this.getSearchResults.vehicleLicense,
                userID: this.$typedStore.modules.userModule.getters.userName
            },
            {
                headers: {
                    accept: constants.OctetMimeType
                },
                responseType: 'blob'
            }));
            fileSaver.saveAs(response.data, 'AppealStatement.pdf');
        },
        async updateAppeal() {
            const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');

            if (this.checkAppellantRequiredFields) {
                if (this.getAppealInfo.appeal.appealReason) {
                    const citationInfo = new CitationInfo();
                    let appealfee = 0;
                    let autovoid = null;

                    if (this.$data.appealDecision != null && this.$data.originalReviewDecision != null) {
                        let list: any[] = this.getAppealResultList;
                        if (list.length) {
                            list = list.filter(s => {
                                if (s.code === this.$data.appealDecision) {
                                    return s;
                                }
                            });
                        }

                        if (list.length > 0) {
                            if (list[0].hasOwnProperty('appealFee')) {
                                appealfee = list[0].appealFee;
                            }
                            if (list[0].hasOwnProperty('autoVoid')) {
                                autovoid = list[0].autoVoid;
                            }
                        }

                        if (Number(appealfee) > 0) {
                            citationInfo.citationNumber = this.getSearchResults.citationNumber;
                            citationInfo.originalAmount = Number(this.$data.originalAmt);
                            citationInfo.newAmount = Number(this.$data.originalAmt) + appealfee;
                            citationInfo.source = 'Appeals';
                            citationInfo.historyReason = appealfee.toFixed(2).toString() + ' APPEAL FEE ADDED';
                            citationInfo.userName = this.$typedStore.modules.userModule.getters.userName;
                        }

                        if (autovoid != null) {
                            citationInfo.citationNumber = this.getSearchResults.citationNumber;
                            citationInfo.explanation = this.getAppealInfo.appeal.appealComments;
                            citationInfo.autoVoid = autovoid;
                            citationInfo.reason = 'UPH';
                            citationInfo.userName = this.$typedStore.modules.userModule.getters.userName;
                        }
                    }


                    if (Number(this.$data.citationAmt) !== Number(this.$data.originalAmt)) {
                        citationInfo.citationNumber = this.getSearchResults.citationNumber;
                        citationInfo.originalAmount = Number(this.$data.originalAmt);
                        citationInfo.newAmount = Number(this.$data.citationAmt);
                        citationInfo.source = 'Appeals';
                        citationInfo.historyReason = 'CITATION AMOUNT CHANGED - APPEAL';
                        citationInfo.userName = this.$typedStore.modules.userModule.getters.userName;
                    }

                    if (citationInfo.citationNumber) {
                        const payloadCitation: CitationInfoPayload = {
                            citationInfo,
                            location: this.$typedStore.state.currentLocation
                        };

                        await this.$typedStore.modules.appealModule.actions.updateCitation(payloadCitation);
                        this.$data.originalAmt = Number(this.getSearchResults.remainingBalance).toFixed(2);
                        this.$data.citationAmt = Number(this.getSearchResults.remainingBalance).toFixed(2);
                    }

                    const app = this.getAppealInfo.appeal || new Appeal();
                    if (app.citationNumber == null) {
                        app.citationRecId = this.getSearchResults.citationNumber;
                    }

                    app.appellantNotifiedDate = this.getAppealInfo.appellantNotifiedDate;
                    app.reviewDate = this.getAppealInfo.reviewDate;
                    app.requestForAppealDate = this.getAppealInfo.requestForAppealDate;
                    app.appealDecision = this.$data.appealDecision;

                    const payload: AppealHearingPayload = {
                        parameters: {
                            appeal: app,
                            vehicleLicense: this.getSearchResults.vehicleLicense,
                            vehicleState: this.getSearchResults.vehicleState,
                            hearing: null,
                            action: 'EditAppeal',
                            citationNumber: this.getSearchResults.citationNumber,
                            userID: this.$typedStore.modules.userModule.getters.userName
                        },
                        location: this.$typedStore.state.currentLocation
                    };

                    await this.$typedStore.modules.appealModule.actions.updateAppeal(payload);
                    await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);
                } else {
                    const messageNoReason: TranslateResult = this.$t('appeals.appealInfo.errorNoReason');
                    await this.$bvModal.msgBoxConfirm(messageNoReason.toString(), msgBoxOptions);
                    return;
                }
                return;
            }

            const message: TranslateResult = this.$t('appeals.information.appellant.appellantErrorMessage');
            if (await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                this.$router.push({
                    name: 'information', params: { location: this.location }
                });
            } else {
                return;
            }
        },
    },
});

export default component;
